import EditBase from "../EditBase"

class EditSquare extends EditBase{


    constructor(options) {
        super(options);
    }
    checkRotatePoint(){
        return false;
    }
    initProperty() {
        var $this = this;
        var positions = [];
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            positions = $this.plot.attrPlot["edit_positions"];
            return new $this.Cesium.PolygonHierarchy($this.drawBase.square(positions));
        }, false);
        this.plot.polygon.hierarchy = hierarchyProperty;
    }

    initKeyPoint() {
        if (!this.checkKeyPoint()) {
            return;
        }
        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        var e_pos = [];
        for (let i = 1; i < keyPos.length; i++) {
            var entity = this.createEnity();
            var point = this.createPoint(this.getDefaultStyle("point_Nor"));
            entity.show = false;
            entity.position = keyPos[i];
            entity.point = point;
            this.viewer.entities.add(entity);
            this.entities.push(entity);
            entity.attrPlot = {
                e_index: i,
                editGuid: this.editGuid,
                edit_keyFlag: true
            };
            e_pos.push(entity);
        }
        this.plot.attrPlot["edit_keyPos"] = e_pos; //实体
    }

    initCenterPoint() {
        if (!this.checkCenterPoint()) {
            return;
        }
        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        if (keyPos.length >= 2) {
            var cartesian3 =keyPos[0];
            var entity = this.createEnity();
            var point = this.createPoint(this.getDefaultStyle("point_Center"));
            entity.show = false;
            entity.position = cartesian3;
            entity.point = point;
            entity.attrPlot = {
                editGuid: this.editGuid,
                edit_centerFlag: true
            };
            this.viewer.entities.add(entity);
            this.entities.push(entity);
            this.plot.attrPlot["edit_center"] = entity; //实体
            this.plot.attrPlot['center_cartesian3'] = cartesian3;
        }
    }

    updateCenter() {
        if (!this.checkCenterPoint()) {
            return;
        }
        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        var centerPos = this.plot.attrPlot["edit_center"];
        if (!centerPos || keyPos.length < 2) {
            return
        }
        var cartesian3 =keyPos[0]
        centerPos.position.setValue(cartesian3); //更新坐标
        this.plot.attrPlot['center_cartesian3'] = cartesian3;
    }

    rotationAll(position) {
        var $this = this;
        var center = this.plot.attrPlot['center_cartesian3'];
        var PA = this.plot.attrPlot['startPoint'];
        var angle = this.getAngleCenterPointDir(center, PA, position);
        if (isNaN(angle)) {
            return;
        }
        let theta = angle * (180 / Math.PI);
        var newPos = this.getRotateCenterPoint(center, PA, theta);
        this.rotationPos.position.setValue(newPos); //更新旋转点
        var positions = this.plot.attrPlot["edit_positions"];
        var positions_copy = this.plot.attrPlot["edit_positions_copy"]
        for (let i = 1; i < positions_copy.length; i++) {
            var p = positions_copy[i];
            var newPos = this.getRotateCenterPoint(center, p, theta);
            positions[i] = newPos;
            $this.plot.attrPlot["edit_keyPos"][i-1].position.setValue(newPos);
        }
    }

}

export default EditSquare;